/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_PlatformsInputs */

const en_pc_alt_col_platforms = /** @type {(inputs: Pc_Alt_Col_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const zh_pc_alt_col_platforms = /** @type {(inputs: Pc_Alt_Col_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Pc_Alt_Col_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_platforms = /** @type {((inputs?: Pc_Alt_Col_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_platforms(inputs)
	return zh_pc_alt_col_platforms(inputs)
});
export { pc_alt_col_platforms as "pc.alt.col.platforms" }